module.exports = __webpack_public_path__ + "static/img/浮尘.634c4afb.svg";